import * as React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Button, FormGroup, Form, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import * as DTO from '../service/DTOs';
import * as TF from '../service/tradeflow';
import { AppState } from '../service/AppState';
//import moment from 'moment';
//import 'moment-duration-format';
//import * as momentDurationFormat from "moment-duration-format";

import moment from 'moment';
import 'moment-duration-format';
//import * as MD from 'react-md';


type FooterProps = FooterState & { xsrfToken?: string } & { onDismissToast: () => void };

interface FooterState {
    connection: DTO.HubConnection;
    syshdr: DTO.SystemHeader;
    tradesession?: DTO.TradeSessionDto;
    toasts: DTO.ToastMessage[];
    appState: AppState;
    //online?: boolean;
}

export class Footer extends React.Component<FooterProps> {

    constructor(props: FooterProps) {
        super(props);
        //this.handleChange = this.handleChange.bind(this);
    }

    //getValidationState = (): "success" | "warning" | "error" => {
    //    var emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    //    //return emailRegex.test(this.state.email) ? "success" : null;
    //    return emailRegex.test(this.state.email) ? "success" : "error";
    //}

    //handleChange = (e: any) => {
    //    this.setState({ email: e.target.value });
    //}

    //submitEmail = (event: React.FormEvent<Form>) => {
    //    this.props.submitEmail(this.state);
    //    event.preventDefault();
    //}

    //submitDisabled = () => {
    //    return this.props.isSubmitting || this.getValidationState() === "error";
    //}

    humanizeDuration = function (dur: moment.Duration) {
        let eventMDuration = moment.duration(dur, 'seconds');
        let result = undefined;

        //eventMDuration = moment.duration(-31, 'seconds');

        if (eventMDuration.asSeconds() < 120.0) {
            result = eventMDuration.format("m [minutes], ss [seconds]", 0, {
                userLocale: "ru-RU",
                //trim: false
            });
            if (eventMDuration.asSeconds() < 0.0) {
                result = '--';
            }
        }
        else {
            result = eventMDuration.format("d [days], h [hours], m [minutes]", 0, {
                userLocale: "ru-RU"
            });
        }

        return result.trim();
    }

    public render() {
        var connectionSts;
        var serverTime;
        var changeIndicator;


        let REFERENCE = this.props.syshdr.time ? moment(this.props.syshdr.time) : moment();
        let REFERENCE2 = REFERENCE.clone().utc();
        var TODAY = REFERENCE.clone().utc().startOf('day');

        if (this.props.connection.status == 'connected' || this.props.connection.status == 'slow') {
            if (this.props.connection.status == 'connected') {
                connectionSts = <div><b>Hub: </b><span className='glyphicon glyphicon-link'></span> On-line</div>
            }
            else {
                connectionSts = <div><b>Hub: </b><span className='glyphicon glyphicon-warning-sign'></span> Slow >>></div>
            }


            if (this.props.syshdr.hasfreshchanges) {
                changeIndicator = <div><span title='Получены новые данные' className='glyphicon glyphicon-flag' style={{ animation: 'attention_blink_muted 1s infinite' }}></span></div>
            }
            else {
                changeIndicator = '';
            }

            if (this.props.syshdr.time) {
                let dt = moment(this.props.syshdr.time).utc();
                //serverTime = <div><b>Время сервера: </b>{TF.dateFormat(dt, "%d-%m-%Y %H:%M:%S", false)}</div>
                serverTime = <div><b>Время сервера: </b>{dt.format('DD-MM-YYYY HH:mm:ss')}</div>

            }
            else {
                serverTime = undefined;
            }
        }
        else if (this.props.connection.status == 'reconnecting') {
            connectionSts = <div><b>Hub: </b><span className='glyphicon glyphicon-transfer'></span> Подключение...</div>
            serverTime = undefined;
        }
        else if (this.props.connection.status == 'disconnected') {
            connectionSts = <div><b>Hub: </b><span className='glyphicon glyphicon-exclamation-sign'></span> Off-line</div>
            serverTime = undefined;
        }

        //console.log(this.props.tradesession);

        let sessionState = undefined;
        if (this.props.tradesession && serverTime) {
            moment.locale('ru');
            if (this.props.tradesession.isopen) {
                let closeTime = this.props.tradesession.sessionclose ? moment(this.props.tradesession.sessionclose).utc() : undefined;
                var durClose = closeTime ? moment.duration(closeTime.diff(REFERENCE2)) : undefined;
                if (durClose)
                    sessionState = <div><b>До окончания торговой сессии: </b>{this.humanizeDuration(durClose)}</div>
                else
                    sessionState = <div><b>Торговая сессиия активна</b></div>
            }
            else if (!this.props.tradesession.isopen && this.props.tradesession.suspended) {
                sessionState = <div><b>Торги приостановлены</b></div>
            }
            else if (!this.props.tradesession.isopen && !this.props.tradesession.suspended) {
                let openTime = this.props.tradesession.willopen ? moment(this.props.tradesession.willopen).utc() : undefined;
                var durOpen = openTime ? moment.duration(openTime.diff(REFERENCE2)) : undefined;
                if (durOpen)

                    //durOpen.humanize()
                    sessionState = <div><b>До начала торгов : </b>{this.humanizeDuration(durOpen)}</div>
                else
                    sessionState = <div><b>Торги закрыты</b></div>
            }
        }
        else {
            //sessionState = <div><b>Торговая сессиия не определена</b></div>
            sessionState = undefined
        }

        var connectionSts;

        //<MD.Snackbar
        //    id="footer-snackbar"
        //    toasts={this.props.toasts}
        //    autohide={true}
        //    onDismiss={this.props.onDismissToast}
        //    autohideTimeout={3000}
        ///>

        let envTag = TF.getEnvTag();
        let isSpecialCfg = envTag && envTag != 'Production' && envTag != '';
        let markerCls = isSpecialCfg ? ' limited-env' : '';



        return <footer className={'footer' + markerCls}>
            <div className="container" style={{ maxWidth: '95%' }}>
                <div className='navbar-collapse collapse' style={{ width: '100%' }}>
                    <ul className="nav navbar-nav navbar-right">
                        <li className='text-muted' style={{ marginLeft: '10px', marginRight: '50px', marginTop: '17px' }}>
                            {sessionState}
                        </li>
                        <li className='text-muted' style={{ marginLeft: '10px' }}>
                            {changeIndicator}
                        </li>
                        <li className='text-muted' style={{ marginLeft: '10px', marginTop: '17px' }}>
                            {serverTime}
                        </li>
                        <li className='text-muted' style={{ marginLeft: '10px' }}>
                            {connectionSts}
                        </li>
                    </ul>
                </div>

                <p className="text-muted">© {moment().year()} Delta - OTC {this.props.appState.appFamily} System
                    {isSpecialCfg ?
                        <span className="limited-env-name">Специальная конфигурация: {envTag}</span>
                        : undefined}
                </p>

            </div>
        </footer>;
    }
}
